import React from 'react'
import CustomerRfpsTable from '../components/CustomerRfpsTable'
import { legacyLayoutProps } from './constants'

export const Home = () => <CustomerRfpsTable {...legacyLayoutProps} />
